/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramAvailableFeaturesControllerGetFeatureByKeyQueryResponse,
  TelegramAvailableFeaturesControllerGetFeatureByKeyPathParams,
} from '../../types/TelegramAvailableFeaturesControllerGetFeatureByKey.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramAvailableFeaturesGetFeatureByKey } from '../../methods/telegramAvailableFeaturesGetFeatureByKey.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramAvailableFeaturesGetFeatureByKeyQueryKey = (
  key: TelegramAvailableFeaturesControllerGetFeatureByKeyPathParams['key'],
) => [{ url: '/api/telegram/available-features/:key', params: { key: key } }] as const;

export type TelegramAvailableFeaturesGetFeatureByKeyQueryKey = ReturnType<
  typeof telegramAvailableFeaturesGetFeatureByKeyQueryKey
>;

export function telegramAvailableFeaturesGetFeatureByKeyQueryOptions(
  key: TelegramAvailableFeaturesControllerGetFeatureByKeyPathParams['key'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramAvailableFeaturesGetFeatureByKeyQueryKey(key);
  return queryOptions<
    TelegramAvailableFeaturesControllerGetFeatureByKeyQueryResponse,
    ResponseErrorConfig<Error>,
    TelegramAvailableFeaturesControllerGetFeatureByKeyQueryResponse,
    typeof queryKey
  >({
    enabled: !!key,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramAvailableFeaturesGetFeatureByKey(key, config);
    },
  });
}

/**
 * {@link /api/telegram/available-features/:key}
 */
export function useTelegramAvailableFeaturesGetFeatureByKey<
  TData = TelegramAvailableFeaturesControllerGetFeatureByKeyQueryResponse,
  TQueryData = TelegramAvailableFeaturesControllerGetFeatureByKeyQueryResponse,
  TQueryKey extends QueryKey = TelegramAvailableFeaturesGetFeatureByKeyQueryKey,
>(
  key: TelegramAvailableFeaturesControllerGetFeatureByKeyPathParams['key'],
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramAvailableFeaturesControllerGetFeatureByKeyQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramAvailableFeaturesGetFeatureByKeyQueryKey(key);

  const query = useQuery(
    {
      ...telegramAvailableFeaturesGetFeatureByKeyQueryOptions(key, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
